import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutWindow"><Path d="M20.5 3.5H21V3H20.5V3.5ZM20.5 20.5V21H21V20.5H20.5ZM3.5 20.5H3V21H3.5V20.5ZM3.5 3.5V3H3V3.5H3.5ZM20 3.5V20.5H21V3.5H20ZM20.5 20H3.5V21H20.5V20ZM4 20.5V3.5H3V20.5H4ZM3.5 4H20.5V3H3.5V4Z" fill="currentColor"/><Path d="M3.5 12H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 3.5V3H11.5V3.5H12.5ZM11.5 20.5V21H12.5V20.5H11.5ZM11.5 3.5V12H12.5V3.5H11.5ZM11.5 12V20.5H12.5V12H11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutWindow;
